import SEO from "@/components/SEO";

export default function CookiePolicy() {
  return (
    <main className="min-h-screen bg-[#FFFCF8] px-4 pb-16 pt-[132px] text-[#351A13] sm:px-8 md:pt-[148px]">
      <SEO title="Cookie Policy" description="How Nityavastra uses browser storage and optional analytics." />
      <div className="mx-auto max-w-3xl">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#7C1F30]">Your privacy</p>
        <h1 className="mt-3 font-serif text-4xl">Cookie Policy</h1>
        <p className="mt-3 text-sm text-[#766154]">Effective date: September 24, 2026</p>

        <div className="mt-8 space-y-7 text-sm leading-7">
          <section>
            <h2 className="font-serif text-2xl">What this covers</h2>
            <p className="mt-2">Cookies and browser storage keep parts of the site working and, if you agree, help us understand site use. Some sign-in providers may also use their own storage when you choose their services.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">Site functions</h2>
            <p className="mt-2">Session storage holds your sign-in token and a temporary return destination during login. Local storage remembers recently viewed products and your analytics choice. Blocking or clearing this storage can affect sign-in or remove those preferences.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">Optional analytics</h2>
            <p className="mt-2">If you accept analytics, we load PostHog to measure page activity and interactions. Session replay may also be enabled. PostHog may place its own browser storage. We do not load its analytics script before you accept. Rejecting analytics leaves the shopping and sign-in functions available.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">Change your choice</h2>
            <p className="mt-2">Use <button type="button" onClick={() => window.dispatchEvent(new Event("nv:open-cookie-preferences"))} className="font-semibold text-[#7C1F30] underline">Cookie preferences</button> to accept or reject analytics at any time. Withdrawing acceptance stops further analytics loading after the page refreshes. You can also clear stored data using your browser settings.</p>
          </section>
          <section>
            <h2 className="font-serif text-2xl">Questions</h2>
            <p className="mt-2">Email <a href="mailto:admin@nityavastra.com" className="font-semibold text-[#7C1F30] underline">admin@nityavastra.com</a> about these choices or your personal information. See the <a href="/privacy-policy" className="font-semibold text-[#7C1F30] underline">Privacy Policy</a> for more information.</p>
          </section>
        </div>
      </div>
    </main>
  );
}
